import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import Global from '../../../../../store/global-selectors';
import { ltlShipmentsGridMessages } from '../messages';

const Carrier = ({ freightShipmentId }: { freightShipmentId: string }) => {
  const shipment = useSelector((state) => Global.selectEntitiesFreightShipmentById(state, { freightShipmentId }));

  return <>{shipment?.carrierName ?? ''}</>;
};

export const carrier = {
  getMessageDescriptor: () => ltlShipmentsGridMessages.carrier,
  name: <FormattedMessage {...ltlShipmentsGridMessages.carrier} />,
  id: 'carrier',
  width: 120,
  minWidth: 70,
  index: 2,
  render: (data: { id: string }) => <Carrier freightShipmentId={data.id} />,
};
